import { DownloadIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { convertPlaneIntersectionToStepFile } from 'features/kestrelViewer/utils/cadExportUtils'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { KVPlaneIntersection } from 'types'

const StyledButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.forecast.activeText};

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background3};
  }
`

export const DownloadPlaneIntersectionStepFile: React.FC<{
  planeIntersection: KVPlaneIntersection
}> = ({ planeIntersection }) => {
  DownloadPlaneIntersectionStepFile.propTypes = {
    planeIntersection: PropTypes.instanceOf(KVPlaneIntersection).isRequired,
  }

  const handleDownload = (planeIntersection: KVPlaneIntersection) => {
    const stepFileContent =
      convertPlaneIntersectionToStepFile(planeIntersection)

    const blob = new Blob([stepFileContent], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'kestrel_plane_intersection.step'
    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    <TooltipWrapper
      side={'right'}
      offset={5}
      label={'Download Plane Intersection as STEP'}>
      <StyledButton onClick={() => handleDownload(planeIntersection)}>
        <DownloadIcon width={16} height={16} />
      </StyledButton>
    </TooltipWrapper>
  )
}
